<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <div class="headerstep">
                <ul class="lst2" [ngClass]="headerClass">
                    <li id="nav-{{stepNav.Key}}" [ngClass]="{active: stepNav.isStage , selected:stepNav.isActive}"   
                        *ngFor="let stepNav of wizardSteps; let i = index" >
                        <a id="link-{{stepNav.Key}}">
                            <span class="circle" [ngClass]="{'circle-shadow': stepNav.isStage}">
                                <em class="{{stepNav.Value}}"></em>
                            </span>
                        </a>
                        <span class="steptext">{{stepNav.Name | translate}}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</div>